import { render, staticRenderFns } from "./index-chats.vue?vue&type=template&id=21bff640&scoped=true&"
import script from "./index-chats.vue?vue&type=script&lang=js&"
export * from "./index-chats.vue?vue&type=script&lang=js&"
import style0 from "./index-chats.vue?vue&type=style&index=0&id=21bff640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bff640",
  null
  
)

export default component.exports